import React, { useState } from "react";
import logo from "../../../assets/Images/Logo AA.png";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";
import { Menu, X } from "lucide-react"; // icons for open/close menu

// Step 1: Navbar data
const navLinks = [
  { id: 1, label: "navbar.home", path: "/" },
  { id: 3, label: "navbar.about", path: "/about" },
  { id: 2, label: "navbar.reflections", path: "/dailyreflections" },
  { id: 4, label: "navbar.meetings", path: "/meetings" },
  { id: 5, label: "navbar.selftest", path: "/selftest" },
  { id: 7, label: "navbar.contact", path: "/contact" },
];

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isTamil = i18n.language === "ta";

  return (
    <header className="sticky top-0 bg-[#032845] text-white shadow-md z-50">
      <div className="container mx-auto flex justify-between items-center py-3 px-3 md:px-16">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img src={logo} alt="AA Logo" className="w-52 md:w-72 h-16 md:h-20 object-contain" />
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:block">
          <ul className="flex space-x-8 text-sm font-semibold">
            {navLinks.map((link) => (
              <li
                key={link.id}
                className={`hover:text-cyan-400 transition-colors duration-200 ${
                  isTamil ? "text-base" : "text-sm"
                }`}
              >
                <a href={link.path}>{t(link.label)}</a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden focus:outline-none"
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#04355e] border-t border-cyan-700">
          <ul className="flex flex-col items-center space-y-4 py-5 text-base font-semibold">
            {navLinks.map((link) => (
              <li
                key={link.id}
                className="hover:text-cyan-400 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)} // close menu on click
              >
                <a href={link.path}>{t(link.label)}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
